import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { LeftNavigationService } from '../../../services/left-navigation.service';

@Component({
  selector: 'app-page-header-new',
  templateUrl: './page-header-new.component.html',
  styleUrls: ['./page-header-new.component.css']
})
export class PageHeaderNewComponent implements OnInit {
  @Output() openFormEvent = new EventEmitter();
  @Output() deleteFormEvent = new EventEmitter();

  @Input() PageHeaderName: string;
  @Input() NoOfSelectedForm: number;

  public subscription: Subscription;
  public currentUrl = '';
  public routeParams;
  public program_status = '';
  public programStatusForm: FormGroup;

  constructor(private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    public router: Router,
    private leftNavigationService: LeftNavigationService) {
  }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.routeParams = this.activeRoute.snapshot.params;

    this.getPageHeaderName();

    if (this.routeParams.status) {
      let statusDropDown = '';
      if (this.routeParams.status === 'inactive') {
        statusDropDown = '0';
      } else if (this.routeParams.status === 'active') {
        statusDropDown = '1';
      } else if (this.routeParams.status === 'archive') {
        statusDropDown = '2';
      }
      this.programStatusForm = this.fb.group({
        program_status: [statusDropDown, [Validators.required]],
      });
    }
  }

  getPageHeaderName() {
    const retrievedObject = localStorage.getItem('routeObject');
    const p = JSON.parse(retrievedObject);
    if (p && p.ClubProgramName !== '') {
      if (p.ClubProgramTypeID === 1) {
        this.PageHeaderName = 'Club Billing - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 2) {
        this.PageHeaderName = 'Tryout - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 3) {
        this.PageHeaderName = 'Team Travel - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 4) {
        this.PageHeaderName = 'Camps / Clinics - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 5) {
        this.PageHeaderName = 'Fundraising - ' + p.ClubProgramName;
      } else if (p.ClubProgramTypeID === 6) {
        this.PageHeaderName = 'All In Program - ' + p.ClubProgramName;
      } else {
        this.PageHeaderName = '';
      }
    } else {
      this.PageHeaderName = '';
    }
  }

  /* Form */
  newForm(obj) {
    this.openFormEvent.emit(obj);
  }
  deleteSelectedForm() {
    this.deleteFormEvent.emit('test');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/page-header-new/page-header-new.component.ts